module.exports = __webpack_public_path__ + "img/pen-gray.ea80d64a.svg";